export const DEFAULT_ERROR_KEY = "general.generic-error";

export const CONFIRM_PROFILE_ERRORS: string[] = ["E_CURRENTCUSTOMER_PERSONALCODEINUSE"];

export const enum CountryCode {
	CO = "CO",
	PE = "PE",
}
